import { ApiService } from "@/api";

export default {
  ADD_ORG(context, newOrg) {
    return ApiService.org.create(newOrg).then((data) => data.id_org);
  },
  UPDATE_ORG(context, { id, data }) {
    return ApiService.org.update(id, data);
  },
  GET_ORG({ commit }, id) {
    return ApiService.org.get(id).then((org) => commit("SET_ORG", org));
  },
  DELETE_ORG(context, id) {
    return ApiService.org.delete(id);
  },
  GET_OPERATOR_PARAMETERS({ commit }) {
    return ApiService.cameras
      .getParameters()
      .then((data) => {
        commit("SET_OPERATOR_PARAMETERS", data);
        return data;
      });
  },
};
